import { useContext } from 'react';
import { useMutation } from '@tanstack/react-query';
import axios from 'axios';
import API_URL from '../constants/environment';
import SessionContext from '../contexts/SessionContext';

export interface CreateTestingLocationsInput {
	organizationId: string;
	mappings: Array<{
		partstraderId: string;
		cccId: string;
		title?: string;
		address?: string;
		city?: string;
		state?: string;
		zip?: string;
	}>;
}

interface CreateTestingLocationsResponse {
	locations: Array<{ _id: string; title: string }>;
}

export const useCreateTestingLocations = () => {
	const sessionContext = useContext(SessionContext);
	const create = async (input: CreateTestingLocationsInput) => {
		const { data } = await axios.post<CreateTestingLocationsResponse>(
			`${API_URL}/onboarding/create-testing-locations`,
			input,
			{ headers: { Authorization: sessionContext?.sessionId ?? '' } }
		);
		return data;
	};

	return useMutation({
		mutationFn: create,
	});
};
